import React, { useState } from 'react'
import { Drawer, Checkbox, DatePicker } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import pluralize from 'pluralize'
import Select from 'react-select'
import Creatable from 'react-select/creatable'

import { useToggle, useListData } from '../../modules'
import NewInventoryItem from './newInventoryItem'
import SelectLabel from '../reusable/selectLabel'

const POItem = ({ onClose, onSave, record = {
    qty: 1,
    vat: 0,
    price: 1,
    name: 'Item X',
    issuedIn: 'Units',
    receivedIn: 'Units'
} }) => {
    const [unit, setUnit] = useState(record?.unit ? { label: record?.unit, value: record?.unit } : null)
    const [units, setUnits] = useState([])
    const [qty, setQty] = useState(record?.qty ?? 0)
    const [price, setPrice] = useState(record?.price ?? 1)
    const [discount, setDiscount] = useState(record?.discount ?? 0)
    const [vat, setVat] = useState(record?.vat ?? 0)
    const [string, setString] = useState('')
    const [inv, setInv] = useState(record?.item)
    const [batch, setBatch] = useState(record?.batch)
    const [account, setAccount] = useState(record?.account ? { label: record?.account?.name, value: record?.account?._id } : null)
    const [expiry, setExpiry] = useState(record?.expiry)
    const [name, setName] = useState(record?.name)
    const [accounts, setAccounts] = useState([])
    const [issuedIn, setIssuedIn] = useState(record?.issuedIn)
    const [receivedIn, setReceivedIn] = useState(record?.receivedIn)
    
    const [singles, toggleSingles, setSingles] = useToggle(record?.issuedIn === record?.receivedIn)
    const [perc, togglePerc] = useToggle()
    const [visible, toggleVisible] = useToggle(true)
    const [newItem, toggleNewItem] = useToggle()
    const [inventory, toggleInventory] = useToggle()

    const history = useHistory()
    const { index } = useParams()

    const [
        { loading: invLoading, fetch: fetchInvItems },
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')
    
    const [
        { loading, error }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('accounts', { string }, { notify: true, manual: false }, 'accounts', 100, ({ accounts: data }) => {
        let obj = {}
        
        data.forEach(acc => {
            if (!obj[acc.type])
                obj[acc.type] = []

            obj[acc.type].push({
                label: acc.name,
                value: acc._id
            })
        })

        let final = []
        for (let typ in obj) {
            final.push({
                label: typ,
                options: obj[typ]
            })
        }

        setAccounts(final)
    })

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    const toggleInv = () => {
        if (inventory) {
            setReceivedIn('Units')
            setIssuedIn('Units')
        }
        
        setInv()
        setName()
        toggleInventory()
    }

    const selectItm = itmm => {
        let sng = itmm.issuedIn === itmm.receivedIn
        setIssuedIn(itmm.issuedIn)
        setReceivedIn(itmm.receivedIn)
        setInv(itmm)
        setName(itmm.name)
        setPrice(0)
        setAccount({ label: itmm.account.name, value: itmm.account._id, ...itmm.account })
    }

    const modify = e => {
        switch (e.target.name) {
            case 'qty':
                setQty(e.target.value)
                break

            case 'name':
                setName(e.target.value)
                break

            case 'price':
                setPrice(e.target.value)
                break

            case 'discount':
                setDiscount(e.target.value)
                break

            case 'vat':
                setVat(e.target.value)
                break

            default:
                break
        }
    }

    const save = () => {
        onSave({ 
            name,
            qty,
            item: inv,
            price, 
            discount: (perc ? price * (discount/100) : discount), 
            vat
        }, index)
        close()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={save} className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">{record ? 'Edit' : 'Add'} Item</p>
            {
                newItem &&
                <NewInventoryItem
                    string={string}
                    onPerform={() => search(string)}
                    toggle={toggleNewItem}
                    visible={newItem} />
            }
            <div className="flex flex-wrap mt-3">
                <Checkbox checked={ inventory } onChange={ toggleInv }>Inventory Item</Checkbox>
                <div className="w-full px-3 mb-1">
                    {
                        inventory ?
                            <>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                    Select Inventory Item
                                </label>
                                <Creatable
                                    className="mb-3"
                                    onCreateOption={toggleNewItem}
                                    isLoading={invLoading}
                                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                                    onInputChange={search}
                                    value={inv}
                                    onChange={selectItm}
                                    options={items.map(itm => ({ label: itm.name, value: itm._id, ...itm }))}
                                    placeholder="Search for inventory item" />
                            </>
                        :
                            <>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Item Name
                                </label>
                                <input
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-name"
                                    name="name"
                                    value={ name }
                                    onChange={ modify }
                                    type="text"
                                    placeholder="Item Name" />
                            </>
                    }
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Quantity
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-qty"
                        type="number"
                        name="qty"
                        value={qty}
                        onChange={modify}
                        placeholder="100" />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Unit
                    </label>
                    <Creatable
                        value={unit}
                        onCreateOption={ val => {
                            let temp = [...units]
                            temp.push(val)
                            setUnits(temp)
                            setUnit({ label: val, value: val })
                        }}
                        onChange={setUnit}
                        options={units.map(unt => ({ label: unt, value: unt }))}
                        placeholder="Select Unit" />
                </div>
                <div className="w-full my-2 px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Unit Price
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-price"
                        type="number"
                        name="price"
                        value={price}
                        onChange={modify}
                        placeholder="Ksh XXX" />
                </div>
                <Checkbox checked={perc} onChange={ togglePerc }>Discount given as percentage</Checkbox>
                <div className="w-full my-2 px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Discount
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-discount"
                        type="number"
                        name="discount"
                        value={discount}
                        onChange={modify}
                        placeholder="14" />
                    <p className="text-gray-500 text-xs italic">Discount as {perc ? 'percentage %' : 'amount'}</p>
                </div>
                <div className="w-full px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        VAT
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-vat"
                        type="number"
                        name="vat"
                        value={vat}
                        onChange={modify}
                        placeholder="16%" />
                </div>
            </div>
        </Drawer>
    )
}

export default POItem